export default __webpack_public_path__ + "static/media/cbc.png";